var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pt-task-list',{ref:"loadmore",staticClass:"pt-task-list__withData",attrs:{"canSelect":_vm.canSelect,"data":_vm.data},on:{"load":_vm.load}})
}
var staticRenderFns = []

export { render, staticRenderFns }